export const paths = {
  manageContent: '/gestione/contenuti',
  mrbrain: '/mrbrain',
  updates: '/updates',
  users: '/gestione/utenti'
}

export const storagePrefix = 'of-adoption-portal-';
const tokens = {
  authToken: null,
  sessionToken: null
}

let authTokenPromise = null;
const storageAuthTokenExpiration = storagePrefix + 'auth-token-expiration';
const storageTrackingSessionToken = storagePrefix + 'tracking-token';
const storageTrackingSessionTokenExpiration = storagePrefix + 'tracking-token-expiration';

export const isMockModeEnabled = localStorage.getItem('ENABLE_MOCK');

export const months = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"]


let _isMobile;

function checkIfIsMobileLayout() {
  const headerMobile = document.querySelector('.header-wrapper');
  if (headerMobile) {
    const headerStyle = window.getComputedStyle(headerMobile)
    const headerMobileDisplay = headerStyle.getPropertyValue('display');
    _isMobile = headerMobileDisplay === 'flex';
  } else {
    _isMobile = window.screen.width < 1024
  }
}

export function isMobile() {
  if (typeof _isMobile !== 'boolean') checkIfIsMobileLayout();
  return _isMobile;
}

export function generateRandomId() {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < 8) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export function isMrBrainPage() {
  return jQuery('#mrbrain-realm').length > 0
}

export function isStreamViewPage() {
  return jQuery('#stream-view-page').length > 0
}

export function getNodePrintedData() {
  return {
    id: jQuery('#node-id').data('value')
  }
}

export async function getAuthToken() {
  //Se abbiamo il token
  if (tokens.authToken && isAuthTokenValid()) {
    return tokens.authToken;
  }

  //Se c'è già una richiesta in corso
  if (authTokenPromise) {
    return authTokenPromise;
  }

  //creo la richiesta
  authTokenPromise = new Promise((resolve, reject) => {
    const url = window.location.origin + '/oauth/token';
    const settings = {
      "url": url,
      "method": "POST",
      "data": {
        "client_id": ofGlobals.clientId,
        "client_secret": ofGlobals.clientSecret,
        "grant_type": "client_credentials",
        "scope": ofGlobals.scope,
      }
    };

    jQuery.ajax(settings)
      .done(function (response) {
        if (!response.access_token) {
          authTokenPromise = null;
          return reject();
        }
        const token = response.access_token;
        const duration = response.expires_in;
        tokens.authToken = token;
        const expiration = Date.now() + (duration * 1000);
        localStorage.setItem(storageAuthTokenExpiration, expiration);
        authTokenPromise = null;
        resolve(token);
      })
      .fail(function (error) {
        authTokenPromise = null;
        reject(error);
      });
  });

  return authTokenPromise;
}

function isAuthTokenValid() {
  // let token = localStorage.getItem(storageAuthToken);
  let expiration = localStorage.getItem(storageAuthTokenExpiration);
  if (!tokens.authToken || !expiration || !new Date(expiration)) return false;
  const now = Date.now();
  const minute = 60000;
  return (now - minute) < expiration;
}

export async function getSessionToken() {
  return new Promise(async (resolve, reject) => {
    // const sessionToken = localStorage.getItem(storageSessionToken);
    if (tokens.sessionToken && isAuthTokenValid()) {
      resolve(tokens.sessionToken);
      return;
    }

    const url = window.location.origin + '/session/token';
    const token = await getAuthToken();

    const settings = {
      "url": url,
      "method": "POST",
      "data": {
        "client_id": ofGlobals.clientId,
        "client_secret": ofGlobals.clientSecret,
        "grant_type": "client_credentials",
        "scope": ofGlobals.scope
      },
      "headers": {
        "Authorization": "Bearer " + token
      },
    };

    await jQuery.ajax(settings)
      .done(function (response) {
        tokens.sessionToken = response
        // localStorage.setItem(storageSessionToken, response)
        resolve(response);
      })
      .catch(function (error) {
        reject(error)
      });
  })
}

export function getUid() {
  return ofGlobals.sessionUid || '';
  // return getCookie('dof_uid_sess');
}

// function getCookie(name) {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop().split(';').shift();
// }

export function showErrorToast(message = '', enableAutoClose = true) {
  let toastMessage = message
  if (!toastMessage) toastMessage = "Si è verificato un errore. Aggiornare la pagina o contattare l'assistenza"
  const id = 'toast-error-' + generateRandomId();
  const toast = `
    <div id="${id}" class="flex max-w-xs lg:w-full max-h-32 overflow-hidden p-4 text-white bg-red-600 rounded-lg shadow-sm" role="alert">
      <div class="inline-flex max-h-32 items-center justify-center shrink-0 rounded-lg">
          <img class="w-5 h-5" src="/themes/custom/adoption_management/assets/icons/info-danger-toast.svg" alt="">
          <span class="sr-only">Error icon</span>
      </div>
      <div class="ms-3 text-sm max-w-xs max-h-xs font-normal overflow-y-auto no-scrollbar whitespace-normal">${toastMessage}</div>
      <div class="flex items-center max-h-32">
      <button id="close-${id}" type="button" class="hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 inline-flex items-center justify-center h-8 w-8" data-dismiss-target="#toast-danger" aria-label="Close">
          <span class="sr-only">Close</span>
          <img class="w-4 h-4 min-w-4 min-h-4" src="/themes/custom/adoption_management/assets/icons/close-white.svg" alt="">
      </button>
      </div>
    </div>
  `;

  jQuery('#toast-container').append(toast);

  if (enableAutoClose) {
    setTimeout(
      function () {
        jQuery(`#${id}`).remove();
      }
      ,10000)
  }

  jQuery(`#close-${id}`).on('click', function () { jQuery(`#${id}`).remove(); })
}

export function showSuccessToast(message = '', enableAutoClose = true) {
  let toastMessage = message
  if (!toastMessage)  toastMessage = "Si è verificato un errore. Aggiornare la pagina o contattare l'assistenza"
  const id = 'toast-error-' + generateRandomId();
  const toast = `
    <div id="${id}" class="flex items-center w-full max-w-xs p-4 text-white bg-green-600 rounded-lg shadow-sm" role="alert">
      <div class="inline-flex items-center justify-center shrink-0 rounded-lg">
          <img class="w-5 h-5" src="/themes/custom/adoption_management/assets/icons/circle-check.svg" alt="">
          <span class="sr-only">Success icon</span>
      </div>
      <div class="ms-3 text-sm font-normal truncate">${toastMessage}</div>
      <button id="close-${id}" type="button" class="hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 inline-flex items-center justify-center h-8 w-8" data-dismiss-target="#toast-danger" aria-label="Close">
          <span class="sr-only">Close</span>
          <img class="w-4 h-4 min-w-4 min-h-4" src="/themes/custom/adoption_management/assets/icons/close-white.svg" alt="">
      </button>
    </div>
  `;

  jQuery('#toast-container').append(toast);

  if (enableAutoClose) {
    setTimeout(
      function () {
        jQuery(`#${id}`).remove();
      }
      ,10000)
  }

  jQuery(`#close-${id}`).on('click', function () { jQuery(`#${id}`).remove(); })
}

export function clearStorage() {
  // localStorage.removeItem(storageAuthToken)
  // localStorage.removeItem(storageSessionToken)
  tokens.authToken = null;
  tokens.sessionToken = null;
  localStorage.removeItem(storageAuthTokenExpiration)
}

export function getQueryParam(key) {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(key);
  return  decodeURIComponent(value);
}


export function convertToISODateFormat(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return '';
  const [day, month, year] = dateStr.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

export function convertToItalianFormat(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return '';
  const [year, month, day] = dateStr.split('-');
  return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
}

export function scrollBodyToBottom() {
  jQuery('html, body').animate({
    scrollTop: jQuery(document).height()
  }, 500);
}

export function scrollBodyToTop() {
  jQuery('html, body').animate({
    scrollTop: 0
  }, 500);
}

export function cleanFileName(name = '') {
  if (!name || typeof name !== 'string') return '';
  return name.replaceAll('.', '_');
}


function setCookie(name, value, minutes) {
  var expires = "";
  if(minutes) {
    expires = "expires=" + new Date(Date.now() + minutes * 60 * 1000).toUTCString() + ";";
  }

  document.cookie = `${name}=${value}; ${expires} path=/; samesite=lax`;
}

function getCookie(name) {
  const cookieArr = document.cookie.split('; ');
  for (const cookie of cookieArr) {
    const [key, value] = cookie.split('=');
    if (key === name) return value;
  }
  return null;
}

export async function fetchSessionId(uid) {
  try {
    const token = await getAuthToken();

    const url = window.location.origin + '/api/v1/tracking/start';

    const response = await jQuery.ajax({
      url: url,
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token
      },
      data: JSON.stringify({uid})
    });
    return response?.sessionId || null;
  } catch (err) {
    console.error('Errore fetchSessionId:', err);
    return null;
  }
}

export async function getTrackingSessionId(){
  return new Promise(async (resolve, reject) => {
    const tokenDuration = 10 * 60 * 1000; // 10 minutes

    const storedToken = getCookie(storageTrackingSessionToken);
    const storedExpiration = getCookie(storageTrackingSessionTokenExpiration);

    const now = Date.now();
    const expiration = storedExpiration ? parseInt(storedExpiration, 10) : 0;

    const isExpired = !storedToken || !expiration || now >= expiration;

    if (isExpired) {
      const token = await getAuthToken();
      const CSRFToken = await getSessionToken();
      fetch(window.location.origin + '/api/v1/tracking/start', {
        method: "POST",
        body: JSON.stringify({
          "uid": getUid()
        }),
        headers: {
          "Content-Type": 'application/json',
          "X-CSRF-Token": CSRFToken,
          "Authorization": "Bearer " + token
        }
      }).then(async (response) => {
        const data = await response.json();
        if(data.session_id) {
          const newExpiration = now + tokenDuration;

          setCookie(storageTrackingSessionToken, data.session_id);
          setCookie(storageTrackingSessionTokenExpiration, newExpiration.toString());

          resolve(data.session_id);
        } else {
          resolve(null);
        }
      })
      .catch(err => {
        reject(err);
      });
    } else {
      // is an old session, we increment the duration
      const newExpiration = now + tokenDuration;
      setCookie(storageTrackingSessionTokenExpiration, newExpiration.toString());

      resolve(storedToken);
    }
  });
}

export async function trackEvent(eventName, eventMessage){
  const allowedEvents = ["PAGE_VIEW", "QUESTION_SUBMITTED"];
  if (!ofGlobals.enableTrackingDocuments && !allowedEvents.includes(eventName)) {
    return;
  }

  return new Promise(async (resolve, reject) => {
    const token = await getAuthToken();
    const CSRFToken = await getSessionToken();
    const uid = getUid();
    const trackingSessionId = await getTrackingSessionId();

    fetch(window.location.origin + '/api/v1/tracking/track', {
      method: "POST",
      body: JSON.stringify({
        "uid": uid,
        "session_id": trackingSessionId,
        "action_type": eventName,
        "action_message": eventMessage
      }),
      headers: {
        "Content-Type": 'application/json',
        "X-CSRF-Token": CSRFToken,
        "Authorization": "Bearer " + token
      }
    }).then(async (response) => {
     resolve(response);
    }).catch(err => {
      console.error("Errore nel tracking:", err);

      reject(err);
    });
  });
}

export function isVideoMimeType(mimeType) {

  if(!mimeType || typeof mimeType === "undefined" || !ofGlobals.enableVideoDocuments) {
    return;
  }

  const videoMimeTypes = [
    "video/mp4",
    "video/webm",
    "video/ogg",
    "video/quicktime",        // .mov
    "video/x-matroska",       // .mkv

    // Formati Microsoft
    "video/x-msvideo",        // .avi
    "video/x-ms-wmv",         // .wmv
    "video/x-ms-asf",         // .asf

    // Formati Adobe / legacy
    "video/x-flv",            // .flv
    "application/x-shockwave-flash", // .swf

    // RealMedia
    "application/vnd.rn-realmedia",  // .rm
    "application/vnd.rn-realmedia-vbr", // .rmvb

    // MPEG
    "video/mpeg",             // .mpg, .mpeg
    "video/mp2t",             // .ts

    // 3GPP / Mobile
    "video/3gpp",             // .3gp
    "video/3gpp2",            // .3g2

    // Apple specific
    "video/x-m4v",            // .m4v

    // AV1 / HEVC / VP9
    "video/av1",              // AV1
    "video/hevc",             // H.265
    "video/h265",             // alias
    "video/h264",             // H.264
    "video/vp8",
    "video/vp9",
  ];

  // check se è in lista o inizia con video/ (catch-all)
  return mimeType.startsWith("video/") || videoMimeTypes.includes(mimeType);
}

export function isAudioMimeType(mimeType) {
  if(!mimeType || typeof mimeType === "undefined" || !ofGlobals.enableAudioDocuments) {
    return;
  }

  const audioMimeTypes = [
    "audio/mpeg",        // .mp3
    "audio/mp3",         // alias
    "audio/wav",         // .wav
    "audio/x-wav",       // varianti wav
    "audio/flac",        // .flac
    "audio/ogg",         // .ogg (può contenere Vorbis/Opus)
    "audio/opus",        // .opus
    "audio/webm",        // .webm con traccia audio

    // Formati Apple
    "audio/aac",         // .aac
    "audio/mp4",         // .m4a
    "audio/x-m4a",       // varianti
    "audio/alac",        // Apple Lossless

    // Formati Microsoft
    "audio/x-ms-wma",    // .wma

    // MIDI
    "audio/midi",        // .mid .midi
    "audio/x-midi",

    // RealAudio
    "audio/vnd.rn-realaudio", // .ra .ram

    // Altro
    "audio/amr",         // Adaptive Multi-Rate (mobile)
    "audio/3gpp",        // audio in container 3gp
    "audio/3gpp2"
  ];

  // check se è in lista o inizia con audio/
  return mimeType.startsWith("audio/") || audioMimeTypes.includes(mimeType);
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

